// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"8c6c3f16","787":"626563bb"}[chunkId] + ".chunk.js";
};